module.exports = "https://cdn.dashboard.gifty.nl/5688/images/mailbox.png?77aac4ed8474eb74280bcbb69fe9650e";